import React, { useContext } from 'react'
import { Grid, Typography, useMediaQuery } from '@mui/material';
import style from "./../../assets/styles/componentStyles/userProfileStyles/userProfileStyle.module.scss";
import popupStyles from "./../../assets/styles/componentStyles/globalPopupStyles.module.scss";
import globalStyle from "../../assets/styles/global.module.scss"
import { isWaSmbUser } from '../../utils/constants';
import { UserContext, UserContextPayload } from '../../context/userContext';
import UserPasswordSection from './userPasswordSection';
import UserTimezoneSection from './userTimezoneSection';
import EditIcon from '@mui/icons-material/Edit';

interface ViewUserDetailPopupProps {
    userDetailsFields: {
        key: string;
        label: string;
        value: string;
        placeholder: string;
        isDisabled: boolean;
        isRequired: boolean;
    }[],
    setFlagEditableFields: React.Dispatch<React.SetStateAction<boolean>>,
    onOpenPasswordForm: () => void,
    onOpenTimezoneForm: () => void,
} 

interface FieldDisplayProps {
    label: string;
    value: string;
    isSmallScreen: boolean;
}

const FieldDisplay: React.FC<FieldDisplayProps> = ({ label, value, isSmallScreen }) => (
    <Grid item xs={12}>
        <Grid container gap="10px" flexWrap="nowrap" direction={isSmallScreen ? "column" : "row"}>
            <Grid item xs={isSmallScreen ? 12 : 4}>
                <Typography className={popupStyles.popupFieldGreyTypography}>
                    {label}
                </Typography>
            </Grid>
            <Grid item xs={isSmallScreen ? 12 : 8}>
                <Typography className={popupStyles.popupFieldTypography}>
                    {value || "-"}
                </Typography>
            </Grid>
        </Grid>
    </Grid>
);

const ViewUserDetailPopup: React.FC<ViewUserDetailPopupProps> = (props) => {

    const { userDetailsFields, setFlagEditableFields, onOpenPasswordForm, onOpenTimezoneForm } = props;
    const isSmallScreen = useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)');

    const { userDetail } = useContext(UserContext) as UserContextPayload;

    return (
        <> 
            <Grid item xs={12}>
                <Grid container gap={"8px"} className={`${globalStyle.displayFlexStyle} ${globalStyle.flexColumn}`}>
                    <Grid item xs={12}>
                        <Grid container className={`${globalStyle.displayFlex}`} gap={1}>
                            <Grid item>
                                <Typography className={style.userDetailTitle}>
                                    User Detail
                                </Typography>
                            </Grid>
                            {/* wa_smb_user can not edit profile */}
                            {(!isWaSmbUser(userDetail?.user_email)) && (
                                <Grid item className={`${globalStyle.displayFlexStyle} ${globalStyle.clickable}`} onClick={() => setFlagEditableFields(true)}>
                                    <EditIcon className={style.editUserDetailIcon} />
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container className={style.userProfileDetailsCard} gap={2}>
                            {userDetailsFields?.map((field) => (
                                <FieldDisplay
                                    key={field?.key}
                                    label={field?.label}
                                    value={field?.value}
                                    isSmallScreen={isSmallScreen}
                                />
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <UserTimezoneSection
                timezoneName={userDetail?.timezone_name}
                onClickTimezoneAction={onOpenTimezoneForm}
            />

            <UserPasswordSection
                isPasswordSet={userDetail?.flag_password}
                onClickPasswordAction={onOpenPasswordForm}
            />
        </>
    )
}

export default ViewUserDetailPopup
